<template>
    <div class="greenLine">
        <div class="container">
            <nav class="navbar navbar-expand-lg sticky-top navbar-light bg-white">
                <div class="container-fluid">
                    <div class="navbar-brand miniStuff">
                        <img src="../images/mini_navbar_logo.png">
                    </div>
                    <div class="navbar-brand phoneStuff">
                        <img src="../images/mini_navbar_logo.png" width="200">
                    </div>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarNav">
                        <ul class="navbar-nav mx-auto">
                            <li class="nav-item m-md-2">
                                <div class="nav-link customCursor" @click="$router.push('/')">Domov</div>
                            </li>
                            <li class="nav-item m-md-2">
                                <a class="nav-link customCursor" @click="$router.push('/vehicles')">Vozni park</a>
                            </li>
                            <li class="nav-item mt-2 mb-2 ms-5 me-5 biggStuff">
                                <img src="../images/navbar_logo.png">
                            </li>
                            <li class="nav-item m-md-2">
                                <div class="nav-link customCursor" @click="$router.push('/contact')">Kontakt</div>
                            </li>
                            <li class="nav-item m-md-2">
                                <div class="nav-link customCursor" @click="$router.push('/about')">O nas</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    </div>
</template>